import { render, staticRenderFns } from "./sidebar-nav.vue?vue&type=template&id=1c24b1a8&scoped=true&"
import script from "./sidebar-nav.vue?vue&type=script&lang=js&"
export * from "./sidebar-nav.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-nav.vue?vue&type=style&index=0&id=1c24b1a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c24b1a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c24b1a8')) {
      api.createRecord('1c24b1a8', component.options)
    } else {
      api.reload('1c24b1a8', component.options)
    }
    module.hot.accept("./sidebar-nav.vue?vue&type=template&id=1c24b1a8&scoped=true&", function () {
      api.rerender('1c24b1a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/theme/layout/sidebar-nav.vue"
export default component.exports